import React, { useState } from 'react';
import { FileText, Check, X, ZoomIn, Edit2, ArrowRight, AlertTriangle, Eye, Download } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function InvestigationWorkbench() {
  const [activeTab, setActiveTab] = useState('shortage');
  return <div className="space-y-6 h-full flex flex-col" data-id="element-337">
      <div className="flex items-center justify-between" data-id="element-338">
        <div data-id="element-339">
          <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-340">
            AI Investigation Workbench
          </h2>
          <p className="text-slate-500 mt-1" data-id="element-341">
            Review AI findings and approve disputes.
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-342">
          <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm font-medium hover:bg-emerald-700 shadow-sm flex items-center space-x-2" data-id="element-343">
            <Check className="w-4 h-4" data-id="element-344" />
            <span data-id="element-345">Approve Dispute</span>
          </button>
        </div>
      </div>

      {/* Case Header */}
      <div className="bg-white rounded-xl border border-slate-200 p-4 shadow-sm flex items-center justify-between" data-id="element-346">
        <div className="flex items-center space-x-6" data-id="element-347">
          <div data-id="element-348">
            <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-349">
              Retailer
            </span>
            <div className="font-bold text-slate-900 flex items-center space-x-2" data-id="element-350">
              <span data-id="element-351">Dollar General</span>
              <StatusBadge status="warning" data-id="element-352">Shortage</StatusBadge>
            </div>
          </div>
          <div className="h-8 w-px bg-slate-200" data-id="element-353"></div>
          <div data-id="element-354">
            <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-355">
              Deduction ID
            </span>
            <div className="font-medium text-slate-900" data-id="element-356">#9982-A21</div>
          </div>
          <div className="h-8 w-px bg-slate-200" data-id="element-357"></div>
          <div data-id="element-358">
            <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold" data-id="element-359">
              Amount
            </span>
            <div className="font-bold text-rose-600" data-id="element-360">-$500.00</div>
          </div>
        </div>
      </div>

      {/* 3-Way Match View */}
      <div className="flex-1 grid grid-cols-3 gap-6 min-h-0" data-id="element-361">
        {/* Column 1: The Claim (The Lie) */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-hidden" data-id="element-362">
          <div className="p-4 bg-slate-50 border-b border-slate-200 flex justify-between items-center" data-id="element-363">
            <div className="flex items-center space-x-2" data-id="element-364">
              <FileText className="w-4 h-4 text-slate-500" data-id="element-365" />
              <h3 className="font-bold text-slate-700" data-id="element-366">The Claim (Retailer)</h3>
            </div>
            <span className="text-xs font-medium text-slate-600 bg-slate-100 px-2 py-1 rounded" data-id="element-367">
              Source: Deduction PDF
            </span>
          </div>

          <div className="p-6 space-y-6 flex-1 overflow-y-auto custom-scrollbar" data-id="element-368">
            <div className="space-y-1" data-id="element-369">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-370">
                Claim Code
              </label>
              <div className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-slate-900 font-medium" data-id="element-371">
                Shortage (Code 14)
              </div>
            </div>

            <div className="space-y-1" data-id="element-372">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-373">
                Item / SKU
              </label>
              <div className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-slate-900" data-id="element-374">
                <div className="font-medium" data-id="element-375">Oral-B Glide Floss</div>
                <div className="text-xs text-slate-500" data-id="element-376">SKU: 123-456-789</div>
              </div>
            </div>

            <div className="space-y-1" data-id="element-377">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-378">
                Qty Claimed (Received)
              </label>
              <div className="p-3 bg-rose-50 rounded-lg border border-rose-200 text-rose-700 font-bold text-lg flex justify-between items-center" data-id="element-379">
                <span data-id="element-380">95 Cases</span>
                <AlertTriangle className="w-5 h-5 text-rose-500" data-id="element-381" />
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-slate-100" data-id="element-382">
              <div className="flex items-center justify-between mb-2" data-id="element-383">
                <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-384">
                  Document Snippet
                </label>
                <button className="text-xs text-blue-600 hover:underline flex items-center" data-id="element-385">
                  <Eye className="w-3 h-3 mr-1" data-id="element-386" /> View Full PDF
                </button>
              </div>
              <div className="h-32 bg-slate-100 rounded-lg border border-slate-200 flex items-center justify-center relative overflow-hidden group cursor-pointer" data-id="element-387">
                <div className="absolute inset-0 bg-black/5 group-hover:bg-black/10 transition-colors" data-id="element-388"></div>
                <img src="https://placehold.co/400x200/e2e8f0/94a3b8?text=PDF+Snippet" alt="PDF Snippet" className="w-full h-full object-cover opacity-50" data-id="element-389" />
                <ZoomIn className="w-6 h-6 text-slate-400 absolute" data-id="element-390" />
              </div>
            </div>
          </div>
        </div>

        {/* Column 2: The Truth (Our ERP) */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-hidden" data-id="element-391">
          <div className="p-4 bg-emerald-50 border-b border-emerald-100 flex justify-between items-center" data-id="element-392">
            <div className="flex items-center space-x-2" data-id="element-393">
              <FileText className="w-4 h-4 text-emerald-600" data-id="element-394" />
              <h3 className="font-bold text-emerald-900" data-id="element-395">
                The Truth (Internal)
              </h3>
            </div>
            <span className="text-xs font-medium text-emerald-700 bg-emerald-100 px-2 py-1 rounded" data-id="element-396">
              Source: ERP + BOL
            </span>
          </div>

          <div className="p-6 space-y-6 flex-1 overflow-y-auto custom-scrollbar" data-id="element-397">
            <div className="space-y-1" data-id="element-398">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-399">
                Invoice Number
              </label>
              <div className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-slate-900 font-medium" data-id="element-400">
                INV-2024-001
              </div>
            </div>

            <div className="space-y-1" data-id="element-401">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-402">
                Item / SKU
              </label>
              <div className="p-3 bg-slate-50 rounded-lg border border-slate-200 text-slate-900" data-id="element-403">
                <div className="font-medium" data-id="element-404">Oral-B Glide Floss</div>
                <div className="text-xs text-slate-500" data-id="element-405">SKU: 123-456-789</div>
              </div>
            </div>

            <div className="space-y-1" data-id="element-406">
              <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-407">
                Invoiced Qty
              </label>
              <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-200 text-emerald-700 font-bold text-lg" data-id="element-408">
                100 Cases
              </div>
            </div>

            <div className="space-y-1" data-id="element-409">
              <div className="flex justify-between items-center" data-id="element-410">
                <label className="text-xs font-semibold text-slate-500 uppercase" data-id="element-411">
                  BOL Signature Analysis
                </label>
                <button className="text-xs text-blue-600 flex items-center" data-id="element-412">
                  <Edit2 className="w-3 h-3 mr-1" data-id="element-413" /> Correct
                </button>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-414">
                <div className="flex items-center justify-between mb-3" data-id="element-415">
                  <span className="text-sm text-slate-600" data-id="element-416">Carrier:</span>
                  <span className="font-medium text-slate-900" data-id="element-417">
                    Swift Transport
                  </span>
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-418">
                  <span className="text-sm text-slate-600" data-id="element-419">Driver Signed:</span>
                  <span className="font-bold text-emerald-600 bg-emerald-100 px-2 py-0.5 rounded" data-id="element-420">
                    100 Cases
                  </span>
                </div>
                <div className="h-24 bg-white rounded border border-slate-200 relative overflow-hidden" data-id="element-421">
                  <img src="https://placehold.co/400x150/ffffff/000000?text=Handwritten+100" alt="Signature Crop" className="w-full h-full object-cover" data-id="element-422" />
                  <div className="absolute bottom-1 right-1 bg-black/70 text-white text-[10px] px-1.5 py-0.5 rounded" data-id="element-423">
                    AI Confidence: 99%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Column 3: The Verdict (AI) */}
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-hidden ring-1 ring-blue-500/20" data-id="element-424">
          <div className="p-4 bg-blue-50 border-b border-blue-100 flex justify-between items-center" data-id="element-425">
            <div className="flex items-center space-x-2" data-id="element-426">
              <Check className="w-4 h-4 text-blue-600" data-id="element-427" />
              <h3 className="font-bold text-blue-900" data-id="element-428">AI Verdict</h3>
            </div>
            <div className="flex items-center gap-2" data-id="element-429">
              <span className="text-xs font-bold text-emerald-700 bg-emerald-100 px-2 py-1 rounded" data-id="element-430">
                98% Match
              </span>
              <span className="text-xs font-medium text-blue-700 bg-blue-100 px-2 py-1 rounded" data-id="element-431">
                AI Logic
              </span>
            </div>
          </div>

          <div className="p-6 space-y-6 flex-1 overflow-y-auto custom-scrollbar" data-id="element-432">
            <div className="p-4 bg-rose-50 border border-rose-100 rounded-lg" data-id="element-433">
              <div className="flex items-center space-x-2 mb-2" data-id="element-434">
                <X className="w-5 h-5 text-rose-500" data-id="element-435" />
                <span className="font-bold text-rose-700" data-id="element-436">
                  Mismatch Detected
                </span>
              </div>
              <p className="text-sm text-rose-800" data-id="element-437">
                Retailer claims 95 cases received, but BOL shows driver signed
                for 100 cases. Shortage occurred in transit (FOB Origin).
              </p>
            </div>

            <div className="space-y-3" data-id="element-438">
              <h4 className="text-sm font-semibold text-slate-900" data-id="element-439">
                Recommended Action
              </h4>
              <div className="flex flex-col space-y-2" data-id="element-440">
                <button className="w-full p-3 bg-emerald-50 border border-emerald-200 rounded-lg flex items-center justify-between group hover:bg-emerald-100 transition-colors text-left" data-id="element-441">
                  <div data-id="element-442">
                    <div className="font-bold text-emerald-700" data-id="element-443">
                      Approve Dispute
                    </div>
                    <div className="text-xs text-emerald-600" data-id="element-444">
                      Generate email packet & queue
                    </div>
                  </div>
                  <Check className="w-5 h-5 text-emerald-500 group-hover:scale-110 transition-transform" data-id="element-445" />
                </button>

                <button className="w-full p-3 bg-white border border-slate-200 rounded-lg flex items-center justify-between group hover:bg-slate-50 transition-colors text-left" data-id="element-446">
                  <div data-id="element-447">
                    <div className="font-medium text-slate-700" data-id="element-448">Write Off</div>
                    <div className="text-xs text-slate-500" data-id="element-449">
                      Amount too small or evidence weak
                    </div>
                  </div>
                  <X className="w-5 h-5 text-slate-400" data-id="element-450" />
                </button>
              </div>
            </div>

            <div className="pt-6 border-t border-slate-100" data-id="element-451">
              <h4 className="text-sm font-semibold text-slate-900 mb-3" data-id="element-452">
                Draft Email Preview
              </h4>
              <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 text-sm text-slate-600 font-mono text-xs leading-relaxed" data-id="element-453">
                <p className="mb-2" data-id="element-454">
                  <span className="font-bold text-slate-900" data-id="element-455">Subject:</span>{' '}
                  Dispute - PO# 12345 - Shortage Claim
                </p>
                <p data-id="element-456">Dear AP Team,</p>
                <p className="mt-2" data-id="element-457">Regarding Deduction #999 for PO #12345.</p>
                <p className="mt-2" data-id="element-458">
                  We invoiced 100 units. Your carrier (Swift Transport) signed
                  for 100 units on the attached BOL (See Page 1).
                </p>
                <p className="mt-2" data-id="element-459">
                  Please repay the shortage of 5 units ($500).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}